"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralSettingsBlank = exports.GeneralSettingsFormSchema = exports.GeneralSettingsRequestDTOSchema = exports.GeneralSettingsDTO = exports.GeneralSettingsDTOSchema = exports.GeneralSettingsSchema = exports.GeneralSettingsBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
var dateUtils_1 = require("./lib/dateUtils");
exports.GeneralSettingsBaseSchema = zod_1.z.object({
    Title: zod_1.z.string().min(1, 'Select a title to continue'),
    FirstName: zod_1.z.string().min(2, 'The First Name must contain at least 2 letters'),
    Nickname: zod_1.z.string().nullish(),
    MiddleNames: zod_1.z.string().nullish(),
    Surname: zod_1.z.string().min(2, 'Surname must contain at least 2 letters'),
    BusinessTel: zod_1.z.string().nullish(),
    Businessmobile: zod_1.z.string().nullish(),
    PersonalMobile: zod_1.z.coerce.string().nullish(),
    HomeNumber: zod_1.z.string().nullish(),
    FaxNumber: zod_1.z.string().nullish(),
    CurrentStatus: zod_1.z.string().nullish(),
    BusinessEmailAddress: zod_1.z.string().email(),
    PersonalEmailAddress: zod_1.z.string().email().nullish(),
    OptOut: zod_1.z.boolean().default(true),
    WhyAreYouJoiningThePYA: zod_1.z.array(zod_1.z.string()).default([]),
    AboutMe: zod_1.z.string().nullish(),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Position: zod_1.z.instanceof(ObjectId_1.ObjectId),
    Nationality: zod_1.z.string().nullish(),
    DateOfBirth: zod_1.z.date({
        required_error: 'Date of Birth is required',
        invalid_type_error: 'Date of Birth must be a valid date',
    }),
});
exports.GeneralSettingsSchema = exports.GeneralSettingsBaseSchema.extend(__assign({}, CommonMongoModelFields_1.CommonMongoModelFields));
exports.GeneralSettingsDTOSchema = exports.GeneralSettingsSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelDTOFields), { UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), DateOfBirth: zod_1.z.string().optional() }));
exports.GeneralSettingsDTO = {
    convertFromModel: function (model) {
        var _a;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            Title: model.Title,
            FirstName: model.FirstName,
            Nickname: model.Nickname,
            MiddleNames: model.MiddleNames,
            Surname: model.Surname,
            BusinessTel: model.BusinessTel,
            Businessmobile: model.Businessmobile,
            PersonalMobile: model.PersonalMobile,
            HomeNumber: model.HomeNumber,
            FaxNumber: model.FaxNumber,
            CurrentStatus: model.CurrentStatus,
            BusinessEmailAddress: model.BusinessEmailAddress,
            PersonalEmailAddress: model.PersonalEmailAddress,
            OptOut: model.OptOut,
            WhyAreYouJoiningThePYA: model.WhyAreYouJoiningThePYA,
            AboutMe: model.AboutMe,
            UserId: model.UserId._id ? model.UserId._id.toString() : model.UserId.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
            // Position: isPopulated(model.Position)
            //   ? PositionDTO.convertFromModel(model.Position as any)
            //   : model.Position?.toString(),
            Position: (_a = model.Position) === null || _a === void 0 ? void 0 : _a.toString(),
            DateOfBirth: typeof model.DateOfBirth === 'string' ? model.DateOfBirth : (0, dateUtils_1.dateToDateString)(model.DateOfBirth),
            Nationality: model.Nationality,
        };
        return dto;
    },
};
exports.GeneralSettingsRequestDTOSchema = exports.GeneralSettingsDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { Position: (0, ObjectId_1.ObjectIdString)('Invalid Position id') }));
// Frontend-specific schema that accepts Date objects for form validation
exports.GeneralSettingsFormSchema = exports.GeneralSettingsRequestDTOSchema.extend({
    DateOfBirth: zod_1.z
        .date({
        required_error: 'Date of Birth is required',
        invalid_type_error: 'Date of Birth must be a valid date',
    })
        .min(new Date('1900-01-01'), 'Date of Birth is too far in the past')
        .max(new Date(), 'Date of Birth cannot be in the future'),
});
exports.GeneralSettingsBlank = {
    FirstName: '',
    BusinessEmailAddress: '',
    Title: '',
    UserId: '',
    OptOut: true,
    Surname: '',
    PersonalMobile: '',
    WhyAreYouJoiningThePYA: [],
    Position: '6620f05cb1c189cf4a04b2d6',
    DateOfBirth: '',
    Nationality: '',
};
//# sourceMappingURL=GeneralSettings.js.map